import { api } from '../configs/axiosConfigs';

export const searchAddresses = async (searchString: string) => {
  return await api.get(`/addresses/autocomplete?search_string=${searchString}`);
};
